import { ProductScreenshot } from 'components/ProductScreenshot';
import JSInstallWeb from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import * as React from 'react';
export default {
  ProductScreenshot,
  JSInstallWeb,
  React
};